export const GET_GROWPLANS_INITIAL_REQUEST = 'GET_GROWPLANS_INITIAL_REQUEST'
export const GET_GROWPLANS_INITIAL_SUCCESS = 'GET_GROWPLANS_INITIAL_SUCCESS'
export const GET_GROWPLANS_INITIAL_FAILURE = 'GET_GROWPLANS_INITIAL_FAILURE'

export const GET_PLATFORM_GROUPS_REQUEST = 'GET_PLATFORM_GROUPS_REQUEST'
export const GET_PLATFORM_GROUPS_SUCCESS = 'GET_PLATFORM_GROUPS_SUCCESS'
export const GET_PLATFORM_GROUPS_FAILURE = 'GET_PLATFORM_GROUPS_FAILURE'

export const POST_LIFECYCLE_REQUEST = 'POST_LIFECYCLE_REQUEST'
export const POST_LIFECYCLE_SUCCESS = 'POST_LIFECYCLE_SUCCESS'
export const POST_LIFECYCLE_FAILURE = 'POST_LIFECYCLE_FAILURE'

export const SAVE_LIFECYCLE_TASK_REQUEST = 'SAVE_LIFECYCLE_TASK_REQUEST'
export const SAVE_LIFECYCLE_TASK_SUCCESS = 'SAVE_LIFECYCLE_TASK_SUCCESS'
export const SAVE_LIFECYCLE_TASK_FAILURE = 'SAVE_LIFECYCLE_TASK_FAILURE'

export const GET_LIFECYCLE_STRAIN_REQUEST = 'GET_LIFECYCLE_STRAIN_REQUEST'
export const GET_LIFECYCLE_STRAIN_SUCCESS = 'GET_LIFECYCLE_STRAIN_SUCCESS'
export const GET_LIFECYCLE_STRAIN_FAILURE = 'GET_LIFECYCLE_STRAIN_FAILURE'

export const SET_PLATFORMS = 'SET_PLATFORMS'
